export enum ConfirmationStateType {
  NO_CONFIRM_NEEDED = 'NO_CONFIRM_NEEDED',
  CONFIRM_NEEDED = 'CONFIRM_NEEDED',
  CONFIRMATION_MISSED = 'CONFIRMATION_MISSED',
  CONFIRMED = 'CONFIRMED',
}
